if (document.querySelector(".cs-logos-slider")) {
  var cs_logoSlider = new Flickity(".cs-logos-slider", {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: "center",
    wrapAround: true,
    autoPlay: true,
  });
  cs_logoSlider.on(
    "staticClick",
    function (event, pointer, cellElement, cellIndex) {
      if (typeof cellIndex == "number") {
        document.querySelector(".cs-logos-content .h2").innerHTML =
          cellElement.querySelector(".quote").innerText;
        cs_logoSlider.selectCell(cellIndex);
      }
    }
  );
  cs_logoSlider.on("change", function (index) {
    if (document.querySelector(".cs-logos-slide-" + index + " .quote")) {
      document.querySelector(".cs-logos-content .h2").innerHTML =
        document.querySelector(
          ".cs-logos-slide-" + index + " .quote"
        ).innerText;
    }
    // if (typeof cellIndex == 'number') {
    //     document.querySelector('.cs-logos-content .h2').innerHTML = cellElement.querySelector('.quote').innerText;
    //     cs_logoSlider.selectCell(cellIndex);
    // }
  });
}
if (document.querySelector(".cs-reviews-slider")) {
  var cs_reviewsSlider = new Flickity(".cs-reviews-slider", {
    prevNextButtons: true,
    pageDots: true,
    cellAlign: "center",
    wrapAround: true,
    watchCSS: true,
  });
  cs_reviewsSlider.on(
    "staticClick",
    function (event, pointer, cellElement, cellIndex) {
      if (typeof cellIndex == "number") {
        cs_reviewsSlider.selectCell(cellIndex);
      }
    }
  );
}

if (document.querySelector(".cs-results-slides")) {
  var cs_resultsSlider = new Flickity(".cs-results-slides", {
    fade: true,
    prevNextButtons: true,
    pageDots: false,
  });
  cs_resultsSlider.on("change", function (index) {
    document.querySelectorAll(".cs-results-content p").forEach((p) => {
      p.classList.remove("active");
    });
    document
      .querySelector(".cs-results-content-p-" + index)
      .classList.add("active");
  });
}

function changeResultsSlide(index) {
  console.log(index);
  cs_resultsSlider.selectCell(index);
}
var _learnq = _learnq || [];

if (document.querySelector(".cs-products-slider")) {
  var cs_productSlider = new Flickity(".cs-products-slider", {
    prevNextButtons: true,
    pageDots: false,
    autoPlay: false,
    draggable: true,
    cellAlign: "left",
    wrapAround: true,
    selectedAttraction: 0.2,
    friction: 0.8,
    groupCells: 2,
  });
}

if (document.querySelector(".cs-image-text-slider")) {
  var cs_productSlider = new Flickity(".cs-image-text-slider", {
    prevNextButtons: true,
    pageDots: true,
    autoPlay: false,
    draggable: true,
    cellAlign: "left",
    selectedAttraction: 0.2,
    friction: 0.8,
    wrapAround: true,
    fade: true,
  });
}
